// Publication industry tokens. Editorial — black primary, near-white
// surface, serif display, larger borderRadius dropped (square / minimal).
import { baseTokens } from '../_base/tokens.js';

export const publicationTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#111111',
    colorInfo: '#111111',
    colorLink: '#111111',
    colorPrimaryHover: '#374151',
    colorLinkHover: '#374151',
    colorPrimaryActive: '#000000',
    colorWarning: '#a16207',
    borderRadius: 2,
    fontFamily:
      "'Source Sans 3', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    ...baseTokens.components,
    Button: { borderRadius: 0 },
    Card: { borderRadiusLG: 2 },
  },
};
